import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { USER_EMAIL_SETTINGS_KEY } from '@utils/backend-api/settings';
import {
  UnsubscribeFromWeeklyDigestResponse,
  unsubscribeFromWeeklyDigest,
} from '@utils/backend-api/unsubscribeFromWeeklyDigest';

export default function useSignUpForWeeklyDigest() {
  const queryClient = useQueryClient();
  const { mutate, isLoading, isError } = useMutation(
    async () => {
      const data = await unsubscribeFromWeeklyDigest();
      queryClient.invalidateQueries(USER_EMAIL_SETTINGS_KEY);
      toast.success(data?.message);
    },
    {
      onError: (data: UnsubscribeFromWeeklyDigestResponse) => {
        toast.error(data?.message);
      },
    }
  );

  return { mutate, isLoading, isError };
}
